import { render, staticRenderFns } from "./lease.vue?vue&type=template&id=c316af16&scoped=true"
import script from "./lease.vue?vue&type=script&lang=js"
export * from "./lease.vue?vue&type=script&lang=js"
import style0 from "./lease.vue?vue&type=style&index=0&id=c316af16&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c316af16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c316af16')) {
      api.createRecord('c316af16', component.options)
    } else {
      api.reload('c316af16', component.options)
    }
    module.hot.accept("./lease.vue?vue&type=template&id=c316af16&scoped=true", function () {
      api.rerender('c316af16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/lease.vue"
export default component.exports